module.exports = __webpack_public_path__ + "img/img-auth.e7e5ee30.png";